import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useNavigate } from 'react-router-dom'

function DashboardSelectModal({
  show,
  handleClose,
  dashboards,
  currentId,
  setDashboardId,
  sectionName
}) {
  const navigate = useNavigate()

  const handleSelect = (id) => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('dashboard_id', id)
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`
    navigate(newUrl)
    setDashboardId(id)
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          Select {sectionName} View{' '}
          <Button
            className="py-2 ms-2 px-3 rounded-0 small btn-sm"
            variant="link"
            onClick={() => {
              handleClose()
              navigate('/dashboards')
            }}
          >
            All Views
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {dashboards &&
            dashboards.map((d) => (
              <div
                key={`dashboard-option-${d.id}`}
                className={`col-12 col-md-6`}
              >
                <div
                  className={`card ${
                    d.id === currentId ? 'border-primary' : ''
                  } cursor-pointer`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSelect(d.id)}
                >
                  <div className="card-body">
                    <h5 className="card-title mb-0">{d.name}</h5>
                    <small className="text-muted">
                      {d.description ? d.description : 'No description'}
                    </small>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DashboardSelectModal
